<template>
  <div>
    <div class="nav-space"></div>
    <div class="careers section">
      <div class="container">
        <h1 class="subtitle">大标题大标题</h1>
        <b-container fluid class="mt-3 px-0">
          <b-row no-gutters>
            <b-col cols="12" lg="6" order-lg="1">
              <b-img src="/images/news-0.png" class="right" fluid></b-img>
            </b-col>
            <b-col cols="12" lg="6" order-lg="0" class="">
              <h3>标题标题标题标题标题标题</h3>
              <p>一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字</p>
              <b-button variant="danger" class="rounded-0">点我点我点我</b-button>
            </b-col>
          </b-row>
          <b-row no-gutters class="">
            <b-col cols="12" lg="6" order-lg="0">
              <b-img src="/images/news-0.png" class="" fluid></b-img>
            </b-col>
            <b-col cols="12" lg="6" order-lg="1" class="right">
              <h3>标题标题标题标题标题标题</h3>
              <p>一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字</p>
              <b-button variant="danger" class="rounded-0">点我点我点我</b-button>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col cols="12" lg="6" order-lg="1">
              <b-img src="/images/news-0.png" class="right" fluid></b-img>
            </b-col>
            <b-col cols="12" lg="6" order-lg="0" class="">
              <h3>标题标题标题标题标题标题</h3>
              <p>一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字一段文字</p>
              <b-button variant="danger" class="rounded-0">点我点我点我</b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.nav-space {
  height: 40px;
  background: black;
}
.section {
  padding: 2.5rem 0;
}
.container{
  max-width: 100rem;
  margin: auto;
  padding-left: 0 1.2rem;
}

@include media-breakpoint-up(lg) {
  .subtitle{
    font-size: 2.2rem !important;
    text-align: left;
    padding-left: 0;
    margin: 2rem 0;
  }
  .nav-space {
    height: 60px;
  }
  .section {
    padding: 5rem 0;
  }
  .container{
    padding: 0 2.5rem;
  } 
  .right{
    padding-left: 40px;
  }
  .row{
    margin: 2.5rem 0;
  }
}
</style>